import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
//import { User } from '../../../models/user.model';
import { UserCred } from '../../../models/usercred.model';
import { User } from '../../../models/user.model';
import { Student } from '../../../models/student.model';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';
import { Staff } from 'src/app/models/staff.model';
import { LeaveStaff } from 'src/app/models/leave-staff.model';
import { LeaveHistoryStaff } from 'src/app/models/leave-staff-history.model';
import { AttendanceStaff } from 'src/app/models/attendance-staff.model';
import { Feature } from 'src/app/models/feature.model';
import { AdressDetail } from 'src/app/models/address.model';
import { CalendarByMonth } from 'src/app/models/calendar-month.model';
import { Document } from 'src/app/models/document.model';
import { BankAccount } from 'src/app/models/bankacct.model';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private http: HttpClient,
              private logger: LoggerService, private tokenStorageService: TokenStorageService,) {
  }

  saveStaffData(staff: Staff): Observable<any> {  
    console.log('------------service-----saveStaffData--------')
    return this.http.post<any>(environment.apiBase+'/staff/save',staff);
  }

  addBulkStaff(file: File,deptId: number,designationId: number,courseJson: any,subjectJson: any): Observable<any> {
    const formData: FormData = new FormData();
    if(file == null || file == undefined){
      var dummyTaskFile = new File(["dummy"], environment.dummyFile, {type: "text/plain", });//"dummy.txt"
      formData.append('file', dummyTaskFile);
    }else{
      formData.append('file', file);
    }
    //formData.append('userRole', userRole);
    formData.append('branchName', this.tokenStorageService.getBranchName());
    formData.append('deptId', deptId.toString());
    formData.append('designationId', designationId.toString());
    if(courseJson == null || courseJson == undefined || courseJson == ""){
      formData.append('courseJson', "");
    }else{
      formData.append('courseJson', JSON.stringify(courseJson));
    }
    if(subjectJson == null || subjectJson == undefined || subjectJson == ""){
      formData.append('subjectJson', "");
    }else{
      formData.append('subjectJson', JSON.stringify(subjectJson));
    }    
    
    return this.http.post<any>(environment.apiBase+'/staff/addBulk', formData);
 }
  updateStaffData(staff: Staff): Observable<any> {  
    return this.http.put<any>(environment.apiBase+'/staff/update', staff);
  }
  getStaffBasicData(userName: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/username/'+userName);
  }
  getStaffListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff?page='+page+'&size='+size);
  }
  getStaffListPageForRole(page: number, size: number,role: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff?role='+role+'&page='+page+'&size='+size);
  }
  getAddressByStaffCode(staffCode: string): Observable<AdressDetail> {  
    return this.http.get<AdressDetail>(environment.apiBase+'/staff/address/'+staffCode);
  }
  getBankAcctByStaffCode(staffCode: string): Observable<BankAccount> {  
    return this.http.get<BankAccount>(environment.apiBase+'/staff/bankAcct/'+staffCode);
  }
  getMiscDataByStaffCode(staffCode: string): Observable<Staff> {  
    return this.http.get<Staff>(environment.apiBase+'/staff/misc/'+staffCode);
  }
  assignSubject(staff: Staff): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staff/assignSubject',staff);
  }
  assignClassCourse(staff: Staff): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staff/assignClassCourse',staff);
  }  

  getLeaveTypeList(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/leaveTypes/all');
  }
  getMasterLeaveTypeForStaff(staffCode: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/leave/master/'+staffCode);
  }
  getLeaveListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/leaves?page='+page+'&size='+size);
  }
  
  getLeaveListForStaff(staffCode: string, academicYear: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/leaves/'+staffCode+'/'+academicYear);
  }
  getLeaveListHistoryPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/leaves/history?page='+page+'&size='+size);
  }
  getLeaveHistoryForStaff(page: number, size: number, staffCode: string, academicYear: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/leaveHistory?page='+page+'&size='+size+'&staffCode='+staffCode+'&session='+academicYear);
  }
  applyLeave(leaveTypeCode: string,leaveHistory: LeaveHistoryStaff): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staff/leaves/apply/'+leaveTypeCode,leaveHistory);
  }
  approveRejcetLeave(leaveHistory: LeaveHistoryStaff): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staff/leaves/history/approveReject',leaveHistory);
  }
  searchStaffs(userRole: string): Observable<Staff[]> {
    return this.http.get<any>(environment.apiBase+'/staffs/role/'+userRole);
  }
  saveAttendance(attendanceList: AttendanceStaff[]): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staff/attendance',attendanceList);
  }
  getAttendanceListPage(page: number, size: number,userRole: string,attendDtStr: string ): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/attendance?page='+page+'&size='+size+'&userRole='+userRole+'&attendDtStr='+attendDtStr);
  }
  //Called from salary generate
  getAttendanceForMonthYear(staffCode: string,month: number,year: number ): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/attendance/staff/'+staffCode+'/'+month+'/'+year);
  }
  //called from attendance page in view staff
  getAttendanceByMonth(cbm: CalendarByMonth): Observable<any> {//EventInput[]
    return this.http.get<any>(environment.apiBase+'/attendance/staff/'+cbm.code+'/'+cbm.month+'/'+cbm.year);
  }
  getAttendanceStats(staffCode: string, session: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/attendancestats/staff/'+staffCode+'/'+session);
  }
  getTeacherList(): Observable<Staff[]> {
    return this.http.get<any>(environment.apiBase+'/staffs/role/'+environment.ROLE_TEACHER);
  }
  getDriverList(): Observable<Staff[]> {
    return this.http.get<any>(environment.apiBase+'/staffs/role/'+environment.ROLE_DRIVER);
  }
  
  getSubscribedFeatures(tenant: string): Observable<any> {  
      return this.http.get<any>(environment.companyBase+'/getSubscribedFeatures/'+tenant);
  }
  overrideSubscription(staffCode: string, featureList: Feature[]): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/staffs/overrideSubscription/'+staffCode,featureList);
  }
  uploadProfilePicture(file: File, userName: string, tenant: string): Observable<any> {// userName is nothing but same as admNumber
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('tenant', tenant);
    return this.http.post<any>(environment.apiBase+'/image/uploadProfilePicture', formData);
  }
  /*******************************************Documenrt*************************************************/
  getAllDocuments(staffCode: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/document/staff/'+staffCode);
  }
  downloadFile(documentId: number): any {
    return this.http.get(environment.apiBase+'/document/staff/download/'+documentId, {responseType: 'blob'});
  }
  uploadDocument(document: Document, file: File): Observable<any> {
    const formData: FormData = new FormData();
    if(file){
      formData.append('file', file);
    }else{
      var dummyFile = new File(["dummy"], "dummy.txt", {type: "text/plain", });
      formData.append('file', dummyFile);
    }
    formData.append('staffCode', document.memberCode);
    formData.append('documentType', document.documentType);
    formData.append('documentTitle', document.documentTitle);
    return this.http.post<any>(environment.apiBase+'/document/staff/upload', formData);
  }
  /*******************************Auth Service*******************************************/
  updateUserStatus(staffCode: String): Observable<any> {//enable/disable 
    //return this.http.get<any>(environment.authBase+'/api/user/updateStatus?username='+username+'&userStatus='+userStatus);
    return this.http.delete<any>(environment.apiBase+'/staff/disable/'+staffCode);
  }
  deleteStaff(staffCode: String): Observable<any> {//enable/disable 
    return this.http.delete<any>(environment.apiBase+'/staff/delete/'+staffCode);
  }
  getDisabledStaffListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/get/disabled?page='+page+'&size='+size);
  }
  enableStaffs(staffList: String[]): Observable<any> { 
    //console.log('Service- deletebranches===> ',json) 
    return this.http.post<any>(environment.apiBase+'/staff/enableall',staffList);
  }
  getPastStaffListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/get/past?page='+page+'&size='+size);
  }
  updateBiometric(staff: Staff): Observable<any>{
    return this.http.put<any>(environment.apiBase+'/staff/updateBiometric',staff);
  }
  
  
  
  
  
  
  
  
  /********************************************************/
  getAuthorityList(): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/roles/all');
  }
  getAuthClientList(): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/clients/all');
  }

  getNextStaffId(clientName: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/staff/nextStaffId/'+clientName);
  }

  getUserData(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/userdata');
  }

  getStaffData(id: number): Observable<Staff> {  
    return this.http.get<Staff>(environment.apiBase+'/staff/'+id);
  }
  
  getSampleData(): Observable<any> { 
    return this.http.get<any>('https://jsonplaceholder.typicode.com/todos');
  }
  
}
